var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95429 31.0457 0 20 0C8.95429 0 0 8.95429 0 20C0 31.0457 8.95429 40 20 40Z",
    fill: "#00B8B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2707 16.0442L22.6579 26.1631M11 12.8198H28.3031H11ZM26.9788 12.8198L25.4947 28.9693H13.9614L12.4773 12.8198H26.9788ZM16.1854 12.8198L17.2378 10H22.2183L23.2707 12.8198H16.1854ZM19.728 16.0109V26.1297V16.0109ZM16.1854 16.0442L16.7981 26.1631L16.1854 16.0442Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteTeal);
export default __webpack_public_path__ + "static/media/Icon_Delete_Teal.9e43428f8bdfee233d0d219d30581a09.svg";
export { ForwardRef as ReactComponent };